import { OrderEventInfo } from "../models/common";

export interface OrderStatusType {
  title: string;
  code: number;
  color: string;
}

export const OrderStatus: { [key: string]: OrderStatusType } = {
  ALL: {
    title: '全部',
    code: -2,
    color: '#808080', // 灰色
  },
  UNPAID: {
    title: '待支付',
    code: -1,
    color: '#ff9800', // 橙色
  },
  PENDING: {
    title: '待同意',
    code: 0,
    color: '#2196f3', // 蓝色
  },
  AGREED: {
    title: '已同意',
    code: 1,
    color: '#4caf50', // 绿色
  },
  LOADED: {
    title: '已装货',
    code: 2,
    color: '#00bcd4', // 青色
  },
  DELIVERED: {
    title: '已送达',
    code: 3,
    color: '#3f51b5', // 靛蓝色
  },
  COMPLETED: {
    title: '已完成',
    code: 4,
    color: '#009688', // 蓝绿色
  },
  CANCELLED: {
    title: '已取消',
    code: 80,
    color: '#9e9e9e', // 深灰色
  },
  EXCEPTION: {
    title: '异常',
    code: 99,
    color: '#f44336', // 红色
  },
  RESOLVED: {
    title: '已解决',
    code: 100,
    color: '#8bc34a', // 浅绿色
  },
};


export const getOrderEventsInfo = (events: OrderEventInfo[]): string => {
  if (!events || events.length === 0) {
    return "";
  }
  
  return events
    .map(event => {
      return `${getOrderStatusTitle(event.type)} : ${event.time}`;
    })
    .filter(Boolean)
    .join('\n');
};

// 获取状态颜色
export const getOrderStatusColor = (code: number): string => {
  const status = Object.values(OrderStatus).find(status => status.code === code);
  return status?.color || '#808080';
};

// 获取状态标题
export const getOrderStatusTitle = (code: number): string => {
  const status = Object.values(OrderStatus).find(status => status.code === code);
  return status?.title || '未知状态';

};

export default OrderStatus;